<template>
  <div class="settledBanner">
    <h3>欢迎入驻上船吧邮轮分销平台</h3>
    <p>聚合全球优质邮轮旅游资源</p>
    <div class="settledBtn">
      <div class="OperationButton" v-if="isOperation">
        <el-button class="register" @click="register">即刻入驻</el-button>
        <el-button class="login" @click="login">已申请查看进程</el-button>
      </div>
      <div class="OperationButton" v-else>
        <el-button
          type="primary"
          v-if="status === 0"
          class="skipBtn"
          @click="gotoSettled"
          >申请入驻</el-button
        >
        <el-button
          type="primary"
          v-if="status === 1 || status === 2"
          class="skipBtn"
          @click="gotoSettled"
          >完善入驻信息</el-button
        >
        <el-button
          type="primary"
          v-if="status === 3"
          class="skipBtn"
          @click="gotoSettled"
          >查看审核进度</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "settledBanner",
  data() {
    return {
      userInfo: {}, //用户登录信息
      distributor: false, //是否入住  true 为已入住
      isOperation: true, //是否有操作按钮
      status: 0 //当前状态是什么 是入住还是完善入住，查看进度
    };
  },
  mounted() {
    this.userInfo = this.$store.state.user.userInfo;
    if (this.userInfo) {
      // 登录信息存在
      this.isOperation = false;
      // userData.distributor === ture 入驻成功
      this.distributor = this.userInfo.distributor;
      // 0未申请  1，2待完善 3已完成
      this.status = this.userInfo.step;
    }
  },
  methods: {
    register() {
      this.$modal.show("register-modal");
    },
    login() {
      this.$store.commit('setVisibleRegisterModal', true);
    },
    gotoSettled() {
      // this.$router.push({ name: "process" });
      this.$router.push({ name: "settled-process" });
    }
  },
  computed: {
    UserData() {
      return this.$store.state.user.userInfo;
    },
    OperationStatus() {
      return this.$store.state.user.status;
    }
  },
  watch: {
    OperationStatus(n) {
      this.status = n;
    },
    UserData(info) {
      this.userInfo = info;
      if (this.userInfo) {
        this.isOperation = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
